import classNames from 'classnames'
import { h, JSX } from 'preact'

import { CheckIcon } from '../icon/icon'

export interface ProgressBarItemProps {
    class?: string
    text: string
    completed?: boolean
    disabled?: boolean
    onClick?: () => void
}

export interface ProgressBarProps {
    mode?: 'mobile' | 'desktop'
    items: ProgressBarItemProps[]
    activeIndex: number
}

const renderItem = (
    item: ProgressBarItemProps,
    index: number,
    activeIndex: number,
): JSX.Element => {
    const className = classNames('progress-bar__item', item.class, {
        'progress-bar__item--completed': item.completed,
        'progress-bar__item--disabled': item.disabled,
        'progress-bar__item--current': index === activeIndex,
        'is-next-of-current': index === activeIndex + 1,
        'is-previous-of-current': index === activeIndex - 1,
    })

    return (
        <li class={className} key={index}>
            <div className="progress-bar__bubble" onClick={item.onClick}>
                {item.completed ? (
                    <CheckIcon class="progress-bar__check" />
                ) : (
                    <span className="progress-bar__counter">{index + 1}</span>
                )}
                <span className="progress-bar__text">{item.text}</span>
            </div>
        </li>
    )
}

export const ProgressBar = (props: ProgressBarProps): JSX.Element => {
    const { mode, items, activeIndex } = props

    const className = classNames(
        'progress-bar',
        mode === 'mobile' && 'progress-bar--mobile',
        mode === 'desktop' && 'progress-bar--desktop',
    )

    return (
        <div id="js-progress-bar" class={className}>
            <ul class="progress-bar__items">
                {items.map((item, index) => renderItem(item, index, activeIndex))}
            </ul>
        </div>
    )
}
